import { jsx as _jsx } from "react/jsx-runtime";
import {} from '@crest/platform-contracts/runtime';
import { createContext, useContext, useCallback, useEffect, useMemo, useState, } from 'react';
import { usePlatformApi } from '../api/platform-api-provider.js';
import { PlatformRuntimeBootstrapClient, PlatformRuntimeBootstrapSupersededError, PlatformWebClientUpgradeRequiredError, } from './platform-runtime-bootstrap-client.js';
const PlatformBootstrapContext = createContext(null);
export function PlatformBootstrapProvider(props) {
    const api = usePlatformApi();
    const client = useMemo(() => new PlatformRuntimeBootstrapClient(api, props.webClientVersion, props.releaseCatalogHash), [api, props.releaseCatalogHash, props.webClientVersion]);
    const [bootstrap, setBootstrap] = useState(null);
    const [error, setError] = useState(null);
    const clearClientState = useCallback(() => {
        client.clear();
        setBootstrap(null);
        setError(null);
    }, [client]);
    const reload = useCallback(async (input = {}) => {
        if (input.discardCurrent === true)
            clearClientState();
        setError(null);
        try {
            const loaded = await client.load();
            setBootstrap(loaded.data);
            setError(null);
        }
        catch (requestError) {
            if (!(requestError instanceof PlatformRuntimeBootstrapSupersededError)) {
                setError(requestError instanceof Error ? requestError : new Error('Bootstrap failed.'));
            }
        }
    }, [clearClientState, client]);
    useEffect(() => {
        clearClientState();
        void reload();
        return () => client.clear();
    }, [clearClientState, client, reload]);
    if (error !== null) {
        return (_jsx("main", { className: "crest-startup-state", role: "alert", children: error instanceof PlatformWebClientUpgradeRequiredError
                ? 'A newer CREST web version is required. Refresh after the update is available.'
                : 'CREST could not start. Please sign in again or contact your administrator.' }));
    }
    if (bootstrap === null) {
        return (_jsx("main", { className: "crest-startup-state", "aria-live": "polite", children: "Loading CREST\u2026" }));
    }
    return (_jsx(PlatformBootstrapContext, { value: {
            ...bootstrap,
            controls: { reload, clearClientState },
        }, children: props.children }));
}
export function usePlatformBootstrap() {
    const bootstrap = useContext(PlatformBootstrapContext);
    if (bootstrap === null)
        throw new Error('PlatformBootstrapProvider is missing.');
    return bootstrap;
}
//# sourceMappingURL=platform-bootstrap-provider.js.map